interface YouTubePreviewProps {
  videoId: string;
  title: string;
  href: string;
}

/**
 * Feed-style card for a YouTube reference in an article: thumbnail, play
 * affordance, title. Opens the watch page.
 */
export function YouTubePreview({ videoId, title, href }: YouTubePreviewProps) {
  const thumb = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="my-8 block overflow-hidden rounded-xl border border-line bg-surface no-underline! text-ink!"
    >
      <span className="relative block aspect-video bg-black">
        {/* External YouTube thumbnail; not in next/image remotePatterns. */}
        <img src={thumb} alt="" className="absolute inset-0 size-full object-cover" />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex size-14 items-center justify-center rounded-full bg-black/75 text-white shadow-lg">
            <svg viewBox="0 0 24 24" className="ml-0.5 size-6 fill-current" aria-hidden="true">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
        </span>
      </span>
      <span className="block px-4 py-3">
        <span className="block text-base font-semibold leading-snug">{title}</span>
        <span className="mt-1 block text-sm font-normal text-ink-2!">
          YouTube
        </span>
      </span>
    </a>
  );
}
